import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Separator } from '../ui/separator';

export const ShippingAddressCard = ({ formData, set }) => (
  <Card className="border-stone-taupe/20">
    <CardHeader>
      <CardTitle className="text-charcoal-ink">Shipping Address</CardTitle>
    </CardHeader>
    <CardContent className="space-y-4">
      <div>
        <Label htmlFor="address" className="text-charcoal-ink">Street Address *</Label>
        <Input
          id="address"
          required
          value={formData.address}
          onChange={(e) => set('address', e.target.value)}
          className="bg-white border-stone-taupe/20"
        />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label htmlFor="city" className="text-charcoal-ink">City *</Label>
          <Input id="city" required value={formData.city} onChange={(e) => set('city', e.target.value)} className="bg-white border-stone-taupe/20" />
        </div>
        <div>
          <Label htmlFor="state" className="text-charcoal-ink">State *</Label>
          <Input id="state" required value={formData.state} onChange={(e) => set('state', e.target.value)} className="bg-white border-stone-taupe/20" />
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4">
        <div>
          <Label htmlFor="zip" className="text-charcoal-ink">ZIP Code *</Label>
          <Input id="zip" required value={formData.zip} onChange={(e) => set('zip', e.target.value)} className="bg-white border-stone-taupe/20" />
        </div>
        <div>
          <Label htmlFor="country" className="text-charcoal-ink">Country *</Label>
          <Input id="country" required value={formData.country} onChange={(e) => set('country', e.target.value)} className="bg-white border-stone-taupe/20" />
        </div>
      </div>
    </CardContent>
  </Card>
);

export const OrderSummaryCard = ({ cartItems, subtotal, total }) => (
  <Card className="border-stone-taupe/20 sticky top-32">
    <CardHeader>
      <CardTitle className="text-charcoal-ink">Order Summary</CardTitle>
    </CardHeader>
    <CardContent className="space-y-4">
      {cartItems.map((item) => (
        <div key={`${item.id}-${item.priceType}`} className="flex gap-4">
          <img src={item.image} alt={item.name} className="w-16 h-16 object-cover rounded-md" />
          <div className="flex-grow">
            <h3 className="font-semibold text-charcoal-ink text-sm">{item.name}</h3>
            <p className="text-xs text-stone-taupe capitalize">{item.priceType}</p>
            <p className="text-sm text-charcoal-ink">Qty: {item.quantity}</p>
          </div>
          <p className="font-semibold text-charcoal-ink">${(item.price * item.quantity).toFixed(2)}</p>
        </div>
      ))}

      <Separator className="bg-stone-taupe/20" />

      <div className="space-y-2">
        <div className="flex justify-between text-charcoal-ink">
          <span>Subtotal</span>
          <span>${subtotal.toFixed(2)}</span>
        </div>
        <Separator className="bg-stone-taupe/20" />
        <div className="flex justify-between text-charcoal-ink text-xl font-bold">
          <span>Total</span>
          <span data-testid="checkout-total">${total.toFixed(2)}</span>
        </div>
      </div>
    </CardContent>
  </Card>
);
